import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiPlus,
  FiEdit,
  FiDollarSign,
  FiCalendar,
  FiPercent,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function CommissionRules() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [rules] = useState([
    {
      id: 1,
      ruleName: "Standard Commission",
      commissionType: "Percentage",
      minAmount: 0,
      maxAmount: 100000,
      commissionRate: 0.5,
      effectiveDate: "2024-01-01",
      expiryDate: "2024-12-31",
      status: "Active",
    },
    {
      id: 2,
      ruleName: "High Volume Commission",
      commissionType: "Percentage",
      minAmount: 100000,
      maxAmount: 500000,
      commissionRate: 0.75,
      effectiveDate: "2024-01-01",
      expiryDate: "2024-12-31",
      status: "Active",
    },
    {
      id: 3,
      ruleName: "Premium Commission",
      commissionType: "Percentage",
      minAmount: 500000,
      maxAmount: null,
      commissionRate: 1.0,
      effectiveDate: "2024-01-01",
      expiryDate: "2024-12-31",
      status: "Active",
    },
  ]);

  const handleCreateRule = () => {
    Swal.fire({
      title: "Create Commission Rule",
      html: `
        <input id="ruleName" class="swal2-input" placeholder="Rule Name" required>
        <select id="commissionType" class="swal2-select">
          <option value="Percentage">Percentage</option>
          <option value="Fixed">Fixed</option>
        </select>
        <input id="minAmount" class="swal2-input" type="number" placeholder="Min Amount (₹)" required>
        <input id="maxAmount" class="swal2-input" type="number" placeholder="Max Amount (₹)">
        <input id="commissionRate" class="swal2-input" type="number" step="0.01" placeholder="Commission Rate" required>
        <input id="effectiveDate" class="swal2-input" type="date" placeholder="Effective Date" required>
        <input id="expiryDate" class="swal2-input" type="date" placeholder="Expiry Date">
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Create Rule",
      confirmButtonColor: "#006e82",
    });
  };

  const handleRunPayout = () => {
    Swal.fire({
      title: "Run Payout Calculation?",
      text: "This will calculate commissions for all agents.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Run Calculation",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Calculating...",
          text: "Please wait while we calculate payouts.",
          icon: "info",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        setTimeout(() => {
          Swal.fire("Success!", "Payout calculation completed.", "success");
        }, 2000);
      }
    });
  };

  const formatINR = (amount) => {
    if (!amount) return "Unlimited";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const filteredRules = rules.filter((rule) => {
    const matchesSearch =
      rule.ruleName.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === "all" || rule.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredRules.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredRules.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="content-page-header content-page-headersplit">
                <h5>Commission Rules</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/agents/commission-rules">Agents</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Commission Rules
                  </li>
                </ol>
              </nav>

       
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                  <div className="d-flex justify-content-between align-items-center flex-wrap"> {/* Filters */} 
                    <div className="row g-2 flex-grow-1">
                <div className="col-12 col-md-6">
                  <div className="position-relative">
                    <FiSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by rule name..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <select
                    className="form-control"
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setCurrentPage(0);
                    }}
                  >
                    <option value="all">All Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
                </div>
                <div className="ms-md-3 mt-3 mt-md-0">
                <button className="btn btn-primary me-2" onClick={handleRunPayout}>
                  Run Payout
                </button>
                <button className="btn btn-primary" onClick={handleCreateRule}>
                  Create Rule
                </button>
              </div>
              </div>
            </div>

            {/* Rules Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Rule Name</th>
                          <th>Type</th>
                          <th>Amount Range</th>
                          <th>Commission Rate</th>
                          <th>Effective Date</th>
                          <th>Expiry Date</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="8">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((rule) => (
                            <tr key={rule.id}>
                              <td style={{ fontWeight: "500" }}>{rule.ruleName}</td>
                              <td>
                                <span className="badge" style={{
                                  background: "#f0f9ff",
                                  color: "#006e82",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}>
                                  {rule.commissionType}
                                </span>
                              </td>
                              <td>
                                {formatINR(rule.minAmount)} - {formatINR(rule.maxAmount)}
                              </td>
                              <td style={{ fontWeight: "600" }}>{rule.commissionRate}%</td>
                              <td>{rule.effectiveDate}</td>
                              <td>{rule.expiryDate}</td>
                              <td>
                                <span className={rule.status === "Active" ? "badge-active" : "badge-pending"}>
                                  {rule.status}
                                </span>
                              </td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  <div
                                    className="delete-table"
                                    title="Edit Rule"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
